import { warehouseItemWorkRequestIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const cancelItemWorkRequest = {
  name: "cancelItemWorkRequest" as const,
  input: z.object({ id: warehouseItemWorkRequestIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
